import React, {  useRef } from 'react'
import {Bar, getElementsAtEvent} from 'react-chartjs-2'
import '../../../styles/report.css'

const KeyAreaGraph = (props) => {
    const chartRef = useRef(null);
    let graphcolors = ['#4eb748', '#E7C61E', '#E6323A', '#c0c0c0']
    const lables = props.graph.BarChart.map(val => val.Visible=="1" ? val.Title : null).filter(n => n)
    const dataset = props.graph.BarChart.map(val => val.Visible=="1" ? val.Score : null).filter(n => n)
    const colors = props.graph.BarChart.map(val => val.Visible=="1" ? graphcolors[val.ValueGrade-1]: null).filter(n => n)

    const data = {
        labels:lables,
        datasets: [{
            data: dataset,
            backgroundColor: colors,
            borderWidth: 0
        }]
    }
    const handleScrollToSection = (evt) => {
        let chartElement = getElementsAtEvent(chartRef.current,evt)
        let index = chartElement[0].index
   
        const element = document.getElementById("key_area_section_"+lables[index].toLowerCase());
    
        if (element) {
    
            element.scrollIntoView({

                block: "start",
                inline: "start",
                behavior: "smooth"
            });
        }
    };
    const config = {
        type: 'bar',
        data: data,
        options: {
            maintainAspectRatio: false,
            scales: {
                y: {
                    beginAtZero: true,
                    max: 100,
                    grid: {
                        display: true
                    },
                    ticks: {
                        stepSize: 20
                    }
                }, 
                x: {
                    grid: {
                        display: false
                    }
                }
            },
            plugins: {
                legend: {
                    display: false
                },
                title:{
                    display: true,
                    text:props.graph.Label,
                    padding: {
                        top: 10,
                        bottom: 10
                    },
                    font: {
                      size: 20,
                    //   style: 'italic',
                    //   family: 'Helvetica Neue'
                    }
                },
            },
        
        }
    }

    return (
        <Bar 
            ref={chartRef}
            data={data} 
            options={config.options}
            onClick={handleScrollToSection}
            width="100%"
            />
    )
}

export default KeyAreaGraph